
import React, { Component } from "react";
import { Col, Button, Input, Modal, ModalHeader, ModalBody, ModalFooter, Row, Form } from 'reactstrap';
import { globals } from "../Globals/Globals";
//import { send_custom_emailV2, MailsyncObjectParameters } from 'datasync-mail';
import { GetFormValue3Tiers, SaveDataTierToDatasync } from 'datasync-core';
import {DsDynamicForm} from "datasync-dynamic-form";

// Type definitions for form structure
interface FormField {
  name: string;
  title?: string;
  placeholder: string;
  input_type: string;
  min_length: number;
  max_length: number;
  required: boolean;
}

interface FormCol {
  Fields: FormField[];
}

interface FormRow {
  Cols: FormCol[];
}

interface ContactFormDefinition {
  version: string;
  Rows: FormRow[];
}


// Type definitions for saved contact form data
interface SavedContactFormData {
  data_blob: any;
}

// Props interface (empty for this component)
interface ContactFormProps {}

// State interface
interface ContactFormState {
  captcha?: string;
}

class ContactForm extends Component<ContactFormProps, ContactFormState> {
    private contact_form: ContactFormDefinition;

    constructor(props: ContactFormProps) {
        super(props);

        /** Form declaration */
        this.contact_form = {
          version: String(globals.parameters.form_version),
          Rows: [{
          Cols: [{
              Fields: [
              {
              name: "last_name",
              title: "Nom de famille",
              placeholder: "Nom de famille",
              input_type: "text",
              min_length: 3,
              max_length: 20,
              required: true,
              },
              {
              name: "first_name",
              placeholder: "Prénom",
              input_type: "text",
              min_length: 3,
              max_length: 20,
              required: true,
              },
              {
              name: "e_mail",
              title: "Adresse électronique",
              placeholder: "courriel",
              input_type: "email",
              min_length: 5,
              max_length: 40,
              required: true,
              },
              {
              name: "contact_message",
              placeholder: "Ecrivez nous...",
              title: "Votre message",
              input_type: "memo",
              min_length: -1,
              max_length: -1,
              required: true,
              },
              {
              name: "human_captcha",
              placeholder: "Je ne suis pas un robot",
              title: "Votre message",
              input_type: "captcha",
              min_length: -1,
              max_length: -1,
              required: false,
              }
              ]
          }]
          }]
        };
        
    }

    
    handle_captcha = (e: React.ChangeEvent<HTMLInputElement>): void => {
        e.preventDefault();

        this.setState({ captcha: e.target.value }, () => { this.checkValidation(e.target.name); });
    }

    Randomize = (min: number, max: number): number => {
        return Math.floor(min + Math.random() * (max - min));
    }
    
    contact_form_saved_handler = (blob_data: SavedContactFormData): void => {
        if (globals.parameters.debugging) {
            console.log("contact_form_saved_handler => ", blob_data);
        }
    }

    contact_form_failed_handler = (err: string): void => {
        if (globals.parameters.debugging)
            console.error("contact_form_failed_handler => save failed with this error" + err);

        if (globals.parameters.save_failed_alert)
            alert(err);
    }

    // Added missing checkValidation method referenced in handle_captcha
    private checkValidation = (fieldName: string): void => {
        // Implementation would depend on the validation logic needed
        // This method was called but not defined in the original code
    }

    render = (): JSX.Element => {
        return(
          <>
            <DsDynamicForm
                datasync_url = {globals.datasync_service.url}
                form = {this.contact_form}
                company_guid = {globals.datasync.uNSECURED_thononadvent_company_guid}
                table_guid= {globals.datasync.contact_request_table_guid}
                clearOnSave={true}
                clearOnUpdate={true}
                /*
                onFormSaved = {this.contact_form_saved_handler}
                onFormFailed = {this.contact_form_failed_handler}*/
              />
              </>
            );
    }
}

export default ContactForm;

